import { render, staticRenderFns } from "./BatchSetSpecRemarksDialog.vue?vue&type=template&id=5391b215&scoped=true"
import script from "./BatchSetSpecRemarksDialog.vue?vue&type=script&lang=js"
export * from "./BatchSetSpecRemarksDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchSetSpecRemarksDialog.vue?vue&type=style&index=0&id=5391b215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391b215",
  null
  
)

export default component.exports